import DashboardLayout from '@/views/Layout/DashboardLayout.vue';
import AuthLayout from '@/views/Pages/AuthLayout.vue';
// GeneralViews
import NotFound from '@/views/GeneralViews/NotFoundPage.vue';
import SystemError from '@/views/GeneralViews/SystemError.vue';
import TwoFactorAuth from '../views/Pages/UserProfile/TwoFactorAuth.vue';

// Charts
const Charts = () => import(/* webpackChunkName: "dashboard" */ '@/views/Charts.vue');
// Features
const Features = () => import(/* webpackChunkName: "features" */ '@/views/Features.vue');

// Chefs
const Chefs = () => import(/* webpackChunkName: "chefs" */ '@/views/Chefs/Chefs.vue');
const ViewChef = () => import(/* webpackChunkName: "chefs" */ '@/views/Chefs/Chef.vue');

// Components pages
const Buttons = () => import(/* webpackChunkName: "components" */ '@/views/Components/Buttons.vue');
const Cards = () => import(/* webpackChunkName: "components" */ '@/views/Components/Cards.vue');
const GridSystem = () => import(/* webpackChunkName: "components" */ '@/views/Components/GridSystem.vue');
const Notifications = () => import(/* webpackChunkName: "components" */ '@/views/Components/Notifications.vue');
const Icons = () => import(/* webpackChunkName: "components" */ '@/views/Components/Icons.vue');
const Typography = () => import(/* webpackChunkName: "components" */ '@/views/Components/Typography.vue');

// Dashboard pages
const Dashboard = () => import(/* webpackChunkName: "dashboard" */ '@/views/Dashboard/Dashboard.vue');
const AlternativeDashboard = () => import(/* webpackChunkName: "dashboard" */ '@/views/Dashboard/AlternativeDashboard.vue');
const Widgets = () => import(/* webpackChunkName: "dashboard" */ '@/views/Widgets.vue');
const Recipes = () => import(/* webpackChunkName: "dashboard" */ '@/views/Recipes.vue');
const MyCollections = () => import(/* webpackChunkName: "dashboard" */ '@/views/Collections/MyCollections.vue');
const MyRecipes = () => import(/* webpackChunkName: "dashboard" */ '@/views/MyRecipes.vue');
const Shared = () => import(/* webpackChunkName: "dashboard" */ '@/views/Shared.vue');
const Requests = () => import(/* webpackChunkName: "dashboard" */ '@/views/Requests.vue');
const Deleted = () => import(/* webpackChunkName: "dashboard" */ '@/views/Deleted.vue');

// Forms pages
const FormElements = () => import(/* webpackChunkName: "forms" */ '@/views/Forms/FormElements.vue');
const FormComponents = () => import(/* webpackChunkName: "forms" */ '@/views/Forms/FormComponents.vue');
const FormValidation = () => import(/* webpackChunkName: "forms" */ '@/views/Forms/FormValidation.vue');

// Maps pages
const GoogleMaps = () => import(/* webpackChunkName: "extra" */ '@/views/Maps/GoogleMaps.vue');
const VectorMaps = () => import(/* webpackChunkName: "extra" */ '@/views/Maps/VectorMaps.vue');

// Pages
const User = () => import(/* webpackChunkName: "pages" */ '@/views/Pages/UserProfile.vue');
const Pricing = () => import(/* webpackChunkName: "pages" */ '@/views/Pages/Pricing.vue');
const TimeLine = () => import(/* webpackChunkName: "pages" */ '@/views/Pages/TimeLinePage.vue');
const Login = () => import(/* webpackChunkName: "pages" */ '@/views/Pages/Login.vue');
const GettingStarted = () => import(/* webpackChunkName: "pages" */ '@/views/Pages/GettingStarted.vue');
const Home = () => import(/* webpackChunkName: "pages" */ '@/views/Pages/Home.vue');
const Register = () => import(/* webpackChunkName: "pages" */ '@/views/Pages/Register.vue');
const ForgotPassword = () => import(/* webpackChunkName: "pages" */ '@/views/Pages/ForgotPassword.vue');
const ResetPassword = () => import(/* webpackChunkName: "pages" */ '@/views/Pages/ResetPassword.vue');
const Lock = () => import(/* webpackChunkName: "pages" */ '@/views/Pages/Lock.vue');
const Profile = () => import(/* webpackChunkName: "pages" */ '@/views/Pages/UserProfile.vue');
const Users = () => import(/* webpackChunkName: "pages" */ '@/views/Pages/UsersList.vue');
const AddUser = () => import(/* webpackChunkName: "pages" */ '@/views/Pages/UserAdd.vue');


// TableList pages
const RegularTables = () => import(/* webpackChunkName: "tables" */ '@/views/Tables/RegularTables.vue');
const SortableTables = () => import(/* webpackChunkName: "tables" */ '@/views/Tables/SortableTables.vue');
const PaginatedTables = () => import(/* webpackChunkName: "tables" */ '@/views/Tables/PaginatedTables.vue');

// Ingredients
const Ingredients = () => import(/* webpackChunkName: "ingredients" */ '@/views/Ingredients/Ingredients.vue');
const Ingredient = () => import(/* webpackChunkName: "tags" */ '@/views/Ingredients/Ingredient.vue');
const AddIngredient = () => import(/* webpackChunkName: "ingredients" */ '@/views/Ingredients/AddIngredient.vue')
const EditIngredient = () => import(/* webpackChunkName: "recipes" */ '@/views/Ingredients/EditIngredient.vue')

// TagGroups
const AddTagGroup = () => import(/* webpackChunkName: "tags" */ '@/views/TagGroups/AddTagGroup.vue');
const TagGroups = () => import(/* webpackChunkName: "tags" */ '@/views/TagGroups/TagGroups.vue');
const EditTagGroup = () => import(/* webpackChunkName: "tags" */ '@/views/TagGroups/EditTagGroup.vue');
const TagGroup = () => import(/* webpackChunkName: "tags" */ '@/views/TagGroups/TagGroup.vue');

// Tags
const AddTag = () => import(/* webpackChunkName: "tags" */ '@/views/Tags/AddTags.vue');
const Tags = () => import(/* webpackChunkName: "tags" */ '@/views/Tags/Tags.vue');
const EditTag = () => import(/* webpackChunkName: "tags" */ '@/views/Tags/EditTag.vue');
const ViewTag = () => import(/* webpackChunkName: "tags" */ '@/views/Tags/Tag.vue');

// Collections
const AddCollection = () => import(/* webpackChunkName: "tags" */ '@/views/Collections/AddCollection.vue');
const Collections = () => import(/* webpackChunkName: "tags" */ '@/views/Collections/Collections.vue');
const EditCollection = () => import(/* webpackChunkName: "tags" */ '@/views/Collections/EditCollection.vue');
const Collection = () => import(/* webpackChunkName: "tags" */ '@/views/Collections/Collection.vue');

// Products
const AddProduct = () => import(/* webpackChunkName: "tags" */ '@/views/Products/AddProduct.vue');
const Products = () => import(/* webpackChunkName: "tags" */ '@/views/Products/Products.vue');
const EditProduct = () => import(/* webpackChunkName: "tags" */ '@/views/Products/EditProduct.vue');
const Product = () => import(/* webpackChunkName: "tags" */ '@/views/Products/Product.vue');

// Units
const AddUnit = () => import(/* webpackChunkName: "tags" */ '@/views/Units/AddUnit.vue');
const Units = () => import(/* webpackChunkName: "tags" */ '@/views/Units/Units.vue');
const EditUnit = () => import(/* webpackChunkName: "tags" */ '@/views/Units/EditUnit.vue');
const Unit = () => import(/* webpackChunkName: "tags" */ '@/views/Units/Unit.vue');

// Recipe
const Recipe = () => import(/* webpackChunkName: "recipes" */ '@/views/Recipe/Recipe.vue');
const EditRecipe = () => import(/* webpackChunkName: "recipes" */ '@/views/Recipe/EditRecipe.vue')
const AddEditRecipe = () => import(/* webpackChunkName: "recipes" */ '@/views/Recipe/EditRecipe.vue')
const RecipeUpload = () => import(/* webpackChunkName: "recipes" */ '@/views/Recipe/RecipeUpload.vue')

// Brands
const Brands = () => import(/* webpackChunkName: "dashboard" */ '@/views/Brands/Brands.vue');
const ViewBrand = () => import(/* webpackChunkName: "dashboard" */ '@/views/Brands/Brand.vue');
const AddBrand = () => import(/* webpackChunkName: "dashboard" */ '@/views/Brands/AddBrand.vue');
const EditBrand = () => import(/* webpackChunkName: "dashboard" */ '@/views/Brands/EditBrand.vue');

// Operators
const Operators = () => import(/* webpackChunkName: "dashboard" */ '@/views/Operators/Operators.vue');
const ViewOperator = () => import(/* webpackChunkName: "dashboard" */ '@/views/Operators/Operator.vue');
const AddOperator = () => import(/* webpackChunkName: "dashboard" */ '@/views/Operators/AddOperator.vue');
const EditOperator = () => import(/* webpackChunkName: "dashboard" */ '@/views/Operators/EditOperator.vue');

// Reporting
const UserHistory = () => import(/* webpackChunkName: "dashboard" */ '@/views/Reporting/History.vue');
const AdminReporting = () => import(/* webpackChunkName: "dashboard" */ '@/views/Reporting/AdminReporting.vue');
const PivotTable = () => import(/* webpackChunkName: "dashboard" */ '@/views/Reporting/PivotTable.vue');

// Settings
const ViewSettings = () => import(/* webpackChunkName: "dashboard" */ '@/views/Settings/Settings.vue');
const AddSettings = () => import(/* webpackChunkName: "dashboard" */ '@/views/Settings/AddSettings.vue');
const EditSettings = () => import(/* webpackChunkName: "dashboard" */ '@/views/Settings/EditSettings.vue');
const ViewPrivacyPolicy = () => import(/* webpackChunkName: "dashboard" */ '@/views/Settings/PrivacyPolicy.vue');

let authPages = {
  path: '/',
  component: AuthLayout,
  name: 'Authentication',
  children: [
    {
      path: '/home',
      name: 'Home',
      component: Home,
      meta: {
        noBodyBackground: true,
      },
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
      meta: { isLoggedIn: true }
    },
    {
      path: '/register',
      name: 'Register',
      component: Register,
      meta: { isLoggedIn: true }

    },
    {
      path: '/forgot-password',
      name: 'Forgot Password',
      component: ForgotPassword,
      meta: { isLoggedIn: true }

    },
    {
      path: '/reset-password',
      name: 'Reset Password',
      component: ResetPassword,
      meta: { isLoggedIn: true }

    },
    {
      path: '/pricing',
      name: 'Pricing',
      component: Pricing,
    },
    {
      path: '/lock',
      name: 'Lock',
      component: Lock,
    },
    {
      path: '/getting-started',
      name: 'Getting Started',
      component: GettingStarted,
    },
    {
      path: '/system-error',
      name: 'System Error',
      component: SystemError,
    },
    { path: '*', component: NotFound },
  ],
};
const routes = [
  {
    path: '/',
    component: DashboardLayout,
    redirect: '/dashboard',
    name: 'Dashboard layout',
    children: [
      {
        path: 'dashboard',
        name: 'Features',
        component: Features,
      },
      {
        path: 'chefs',
        name: 'Chefs',
        component: Chefs,
      },
      {
        path: 'chef/:id',
        name: 'Chef',
        component: ViewChef
      },
      {
        path: 'user-profile/:id',
        name: 'User Profile',
        component: Profile,
      },
      {
        path: 'user-profile/twofactorauth/:id',
        name: '2FA Authentication',
        component: TwoFactorAuth,
      },
      {
        path: 'users',
        name: 'Users',
        component: Users,
        meta: { requiresAdmin: true }
      },
      {
        path: 'user/add-user',
        name: 'Add User',
        component: AddUser,
        meta: { requiresAdmin: true }
      },
      {
        path: 'recipes',
        name: 'Recipes',
        component: Recipes,
      },
      {
        path: 'recipes/uploader',
        name: 'Recipe Uploader',
        component: RecipeUpload,
      },
      {
        path: 'recipe/add-recipe',
        name: 'Add Recipe',
        component: AddEditRecipe
      },
      {
        path: 'recipe/edit-recipe/:id',
        name: 'Edit Recipe',
        component: AddEditRecipe
      },
      {
        path: 'recipe/add-edit-recipe/:id?',
        name: 'Add Edit Recipe',
        component: AddEditRecipe
      },
      {
        path: 'recipe/:id',
        name: 'Recipe',
        component: Recipe,
      },
      {
        path: 'ingredients',
        name: 'Ingredients',
        component: Ingredients,
      },
      {
        path: 'ingredient/:id',
        name: 'Ingredient',
        component: Ingredient
      },
      {
        path: 'ingredient/add-ingredient',
        name: 'Add Ingredient',
        component: AddIngredient
      },
      {
        path: 'ingredient/edit-ingredient/:id',
        name: 'Edit Ingredient',
        component: EditIngredient
      },
      {
        path: 'taggroups',
        name: 'Tag Groups',
        component: TagGroups,
      },
      {
        path: 'taggroup/edit-taggroup/:id',
        name: 'Edit Tag Group',
        component: EditTagGroup
      },
      {
        path: 'taggroup/add-taggroup',
        name: 'Add Tag Group',
        component: AddTagGroup
      },
      {
        path: 'taggroup/:id',
        name: 'Tag Group',
        component: TagGroup
      },
      {
        path: 'tags',
        name: 'Tags',
        component: Tags,
      },
      {
        path: 'tag/add-tag',
        name: 'Add Tag',
        component: AddTag
      },
      {
        path: 'tag/edit-tag/:id',
        name: 'Edit Tag',
        component: EditTag
      },
      {
        path: 'tag/:id',
        name: 'Tag',
        component: ViewTag
      },
      {
        path: 'collections',
        name: 'Collections',
        component: Collections,
      },
      {
        path: 'collection/edit-collection/:id',
        name: 'Edit Collection',
        component: EditCollection
      },
      {
        path: 'collection/add-collection',
        name: 'Add Collection',
        component: AddCollection
      },
      {
        path: 'collection/:id',
        name: 'Collection',
        component: Collection
      },
      {
        path: 'units',
        name: 'Units',
        component: Units,
      },
      {
        path: 'unit/edit-unit/:id',
        name: 'Edit Unit',
        component: EditUnit
      },
      {
        path: 'unit/add-unit',
        name: 'Add Unit',
        component: AddUnit
      },
      {
        path: 'unit/:id',
        name: 'Unit',
        component: Unit
      },      
      {
        path: 'products',
        name: 'Products',
        component: Products,
      },
      {
        path: 'product/edit-product/:id',
        name: 'Edit Product',
        component: EditProduct
      },
      {
        path: 'product/add-product',
        name: 'Add Product',
        component: AddProduct
      },
      {
        path: 'product/:id',
        name: 'Product',
        component: Product
      },      
      {
        path: 'brands',
        name: 'Brands',
        component: Brands,
      },
      {
        path: 'brand/add-brand',
        name: 'Add Brand',
        component: AddBrand
      },
      {
        path: 'brand/edit-brand/:id',
        name: 'Edit Brand',
        component: EditBrand
      },
      {
        path: 'brand/:id',
        name: 'Brand',
        component: ViewBrand
      },
      {
        path: 'operators',
        name: 'Operators',
        component: Operators,
      },
      {
        path: 'operator/add-operator',
        name: 'Add Operator',
        component: AddOperator
      },
      {
        path: 'operator/edit-operator/:id',
        name: 'Edit Operator',
        component: EditOperator
      },
      {
        path: 'operator/:id',
        name: 'Operator',
        component: ViewOperator
      },     
      {
        path: 'settings/:id',
        name: 'Settings',
        component: ViewSettings
      },
      {
        path: 'settings/add-settings',
        name: 'Add Settings',
        component: AddSettings
      }, 
      {
        path: 'settings/edit-settings/:id',
        name: 'Edit Settings',
        component: EditSettings
      }, 
      {
        path: 'privacypolicy',
        name: 'Privacy Policy',
        component: ViewPrivacyPolicy
      }, 
      {
        path: 'my-collections',
        name: 'My Collections',
        component: MyCollections,
      },      
      {
        path: 'my-recipes',
        name: 'My Recipes',
        component: MyRecipes,
      },
      {
        path: 'shared',
        name: 'Shared',
        component: Shared,
      }, 
      {
        path: 'requests',
        name: 'Requests',
        component: Requests,
      },
      {
        path: 'deleted',
        name: 'Deleted',
        component: Deleted,
      },
      {
        path: 'history',
        name: 'User History',
        component: UserHistory,
      },
      {
        path: 'adminreporting',
        name: 'Admin Reporting',
        component: AdminReporting,
      },
      {
        path: 'pivottable',
        name: 'Pivot Table',
        component: PivotTable,
      },
    ],
  },
  authPages
];

export default routes;
